function Header(props) {
  return (
    <section className="bg-blue-500">
      <div className="pt-20 pb-4 md:pt-36 md:pb-8">
        <div className="max-w-6xl mx-auto px-4">{props.children}</div>
      </div>
    </section>
  );
}

export default Header;
